import { render, staticRenderFns } from "./TabbedEditor.vue?vue&type=template&id=8610cca2&scoped=true&"
import script from "./TabbedEditor.vue?vue&type=script&lang=js&"
export * from "./TabbedEditor.vue?vue&type=script&lang=js&"
import style0 from "./TabbedEditor.vue?vue&type=style&index=0&id=8610cca2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./TabbedEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8610cca2",
  null
  
)

export default component.exports